import styles from './CellSkeleton.module.css';

export default function CellSkeleton(){

    return(
        <div className={styles['wrap']}>
            <header>
                <div/>
            </header>
            <body>
                <span/>
                <span/>
                <p>
                    <span/>
                    <span/>
                </p>
            </body>
            <hr/>
            <footer>
                <span/>
                <div/>
            </footer>
        </div>
    )
}
